module.exports = __webpack_public_path__ + "static/img/webapps-04.2c474a9f.png";